import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#1A1A1A] text-white py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <img
              src="https://static.readdy.ai/image/cba2a97821e3b69b611dea227959f307/950853c41a0eb7cde6ec67e05d9bbe0d.jpeg"
              alt="Deer Point Contracting"
              className="h-16 w-auto mb-4"
            />
            <p className="text-gray-400 text-sm">
              Building Communities. Renovating Care.
            </p>
          </div>

          <div>
            <h3 className="text-[#C5A55A] font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-[#C5A55A] transition-colors text-sm cursor-pointer">
                  Our Services
                </Link>
              </li>
              <li>
                <Link to="/work" className="text-gray-400 hover:text-[#C5A55A] transition-colors text-sm cursor-pointer">
                  Our Work
                </Link>
              </li>
              <li>
                <Link to="/" className="text-gray-400 hover:text-[#C5A55A] transition-colors text-sm cursor-pointer">
                  Our Team
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-[#C5A55A] transition-colors text-sm cursor-pointer">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-[#C5A55A] font-semibold mb-4">Opportunities</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-[#C5A55A] transition-colors text-sm cursor-pointer">
                  Careers
                </Link>
              </li>
              <li>
                <Link to="/" className="text-gray-400 hover:text-[#C5A55A] transition-colors text-sm cursor-pointer">
                  Trade Partners
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-[#C5A55A] font-semibold mb-4">Contact</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>Richmond, VA</li>
              <li>(804) 555-0100</li>
              <li>info@deerpointcontracting.com</li>
            </ul>
            <div className="flex space-x-4 mt-4">
              <a href="#" className="text-gray-400 hover:text-[#C5A55A] transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-[#C5A55A] transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-[#C5A55A] transition-colors cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center text-sm text-gray-400">
          <p>&copy; 2024 Deer Point Contracting. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}